import { DoctorsSuppliersContext } from 'Context/SuppliersContext/DoctorsSuppliersContext';
import { useContext } from 'react';
import { ResetFilterButtons } from '../../ResetFilterButtons';
import { Stack, SxProps, Typography } from '@mui/material';
import { useDictionary } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { SUPPLIER_RESULT_FILTER } from 'Enum/suppliers';
import { FEMALE_ID, MALE_ID } from 'Config';

export const Gender = () => {
  const { filters, setFilters, dispatchSuppliers } = useContext(
    DoctorsSuppliersContext
  );

  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage;

  const sortStyle: SxProps = {
    p: '6px 0 6px 16px',

    ':hover': {
      cursor: 'pointer',
      bgcolor: 'primary.shade_50_2',
    },
  };

  const genderFilterHandler = (genderId: number) => {
    const updatesFilters = {
      ...filters,
      gender: genderId,
    };
    setFilters(updatesFilters);
    dispatchSuppliers({
      type: SUPPLIER_RESULT_FILTER.doctors,
      payload: { value: updatesFilters },
    });
  };

  const resetGender = () => {
    const updatesFilters = {
      ...filters,
      gender: null,
    };
    setFilters(updatesFilters);
    dispatchSuppliers({
      type: SUPPLIER_RESULT_FILTER.doctors,
      payload: { value: updatesFilters },
    });
  };

  return (
    <Stack
      sx={{
        pb: '60px',
      }}
    >
      <Typography
        variant='body6'
        sx={{
          ...sortStyle,
          bgcolor: filters.gender === MALE_ID ? 'primary.shade_100' : undefined,
          fontWeight: filters.gender === MALE_ID ? '600 !important' : undefined,
        }}
        onClick={() => genderFilterHandler(MALE_ID)}
      >
        {dictionary.doctors.maleDoctor}
      </Typography>
      <Typography
        variant='body6'
        sx={{
          ...sortStyle,
          bgcolor:
            filters.gender === FEMALE_ID ? 'primary.shade_100' : undefined,
          fontWeight:
            filters.gender === FEMALE_ID ? '600 !important' : undefined,
        }}
        onClick={() => genderFilterHandler(FEMALE_ID)}
      >
        {dictionary.doctors.femaleDoctor}
      </Typography>
      <Typography
        variant='body6'
        sx={{
          ...sortStyle,
          bgcolor:
            filters.gender !== MALE_ID && filters.gender !== FEMALE_ID
              ? 'primary.shade_100'
              : undefined,
          fontWeight:
            filters.gender !== MALE_ID && filters.gender !== FEMALE_ID
              ? '600 !important'
              : undefined,
        }}
        onClick={() => resetGender()}
      >
        {dictionary.noPreferences}
      </Typography>
      <ResetFilterButtons
        resetCallback={() => resetGender()}
        sx={{
          justifyContent: 'flex-start',
        }}
      />
    </Stack>
  );
};
